import type { ReactNode } from "react";

export function EmptyState({
  title,
  description,
  action,
}: {
  title: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <div className="text-center py-16">
      <p className="text-sm font-medium text-ink">{title}</p>
      {description && (
        <p className="text-xs text-ink-3 mt-1 max-w-sm mx-auto">{description}</p>
      )}
      {action && <div className="mt-5 inline-block">{action}</div>}
    </div>
  );
}
